import React from 'react';
import {MDBPopover, MDBPopoverBody} from 'mdbreact';
import {FastField, FormikErrors} from 'formik';

import {Grid} from '@material-ui/core';

import AirlineSelectorContainer from 'data/redux/containers/airlineSelectorContainer/AirlineSelectorContainer';
import AirportSelectorContainer from 'data/redux/containers/airportSelectorContainer/AirportSelectorContainer';
import FormikDateTimeSelector from 'gui/components/formikDateTimeSelector/FormikDateTimeSelector';
import {syncDates} from 'gui/components/editors/commons/editor/utils';
import EditorSection from 'gui/components/editors/commons/editor/components/editorSection';
import TicketDescription
  from 'gui/components/editors/flightEditor/components/ticketDetailsForm/components/ticketDetails/components/ticketDescription';
import FormikPlusMinusInput from 'gui/components/formikPlusMinusInput';
import {getDatePlusDays} from 'data/utils/calculators';
import {When} from 'react-if';
import FormikRadiosInput from 'gui/components/formikRadiosInput';
import {ITicketInfo} from 'data/interfaces/products';

const TicketDetails = (props: { forcedRoundTrip: boolean, values: ITicketInfo, errors: FormikErrors<any>, setFieldValue: any, touched: any }) => (
  <EditorSection title="פרטי טיסה">
    <Grid item xs={12} sm={6}>
      <MDBPopover
        placement="top"
        popover
        clickable
        domElement={true}
      >
        <div>
          <FastField
            component={AirlineSelectorContainer}
            label="חברת תעופה הלוך (יש לרשום באנגלית) *"
            name="originFlightCompany"/>
        </div>
        <div>
          <MDBPopoverBody>
            חברת התעופה של הכרטיס/ים
          </MDBPopoverBody>
        </div>
      </MDBPopover>
    </Grid>
    <Grid item xs={12} sm={6}>
      <MDBPopover
        placement="top"
        popover
        clickable
        domElement={true}
      >
        <div>
          <FastField
            component={FormikPlusMinusInput}
            label="מספר כרטיסים"
            name="ticketsAmount"/>
        </div>
        <div>
          <MDBPopoverBody>
            מספר כרטיסים למכירה
          </MDBPopoverBody>
        </div>
      </MDBPopover>
    </Grid>
    <Grid item xs={12} sm={6}>
      <FastField
        component={AirportSelectorContainer}
        label="ממראים מ (יש לרשום באנגלית) *"
        id="originAirport"
        name="originAirport"
        defaultValueQuery="ben gurion"
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <FastField
        component={AirportSelectorContainer}
        label="נוחתים ב (יש לרשום באנגלית) *"
        id="destinationAirport"
        name="destinationAirport"/>
    </Grid>


    <Grid item xs={12} sm={6}>
      <FastField
        component={FormikDateTimeSelector}
        label="תאריך ושעת המראת טיסה הלוך"
        name="originTimeOfTakeOff"
        minDate={getDatePlusDays(1)}
        handleChange={(value) => {
          syncDates(props, 'originTimeOfTakeOff', value);
        }}
        openTo={(props.values.originTimeOfLanding && props.touched.originTimeOfLanding) ? "hours" : "date"}
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <FastField
        component={FormikDateTimeSelector}
        label="תאריך ושעת נחיתת טיסה הלוך"
        name="originTimeOfLanding"
        minDate={props.values.originTimeOfTakeOff ? new Date(props.values.originTimeOfTakeOff) : getDatePlusDays(1)}
        handleChange={(value) => {
          syncDates(props, 'originTimeOfLanding', value);
        }}
        openTo={(props.values.originTimeOfTakeOff && props.touched.originTimeOfTakeOff) ? "hours" : "date"}
      />
    </Grid>

    <When condition={!props.forcedRoundTrip}>
      {() =>
        <Grid item xs={12} sm={6}>
          <FormikRadiosInput
            labelRight={"כיוון אחד"}
            labelLeft={"הלוך ושוב"}
            name="isRoundTripTicket"
            flip
            labelInMiddleMode
          />
        </Grid>
      }
    </When>

    <When condition={!!props.forcedRoundTrip || !!props.values.isRoundTripTicket}>
      {() =>
        <>
          <Grid item xs={12} sm={6}>
            <MDBPopover
              placement="top"
              popover
              clickable
              domElement={true}
            >
              <div>
                <FastField
                  component={AirlineSelectorContainer}
                  label="חברת תעופה חזור (יש לרשום באנגלית) *"
                  name="destinationFlightCompany"/>
              </div>
              <div>
                <MDBPopoverBody>
                  חברת התעופה של הכרטיס/ים לכיוון חזור
                </MDBPopoverBody>
              </div>
            </MDBPopover>
          </Grid>
          <When condition={!!props.forcedRoundTrip}>
            {() => <Grid item xs={12} sm={6}/>}
          </When>

          <Grid item xs={12} sm={6}>
            <FastField
              component={FormikDateTimeSelector}
              label="תאריך וזמן המראת טיסה חזור"
              name="destinationTimeOfTakeOff"
              minDate={props.values.originTimeOfLanding ? new Date(props.values.originTimeOfLanding) : getDatePlusDays(1)}
              handleChange={(value) => {
                syncDates(props, 'destinationTimeOfTakeOff', value);
              }}
              openTo={(props.values.destinationTimeOfLanding && props.touched.destinationTimeOfLanding) ? "hours" : "date"}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FastField
              component={FormikDateTimeSelector}
              label="תאריך וזמן נחיתת טיסה חזור"
              name="destinationTimeOfLanding"
              minDate={props.values.destinationTimeOfTakeOff ? new Date(props.values.destinationTimeOfTakeOff) : getDatePlusDays(1)}
              handleChange={(value) => {
                syncDates(props, 'destinationTimeOfLanding', value);
              }}
              openTo={(props.values.destinationTimeOfTakeOff && props.touched.destinationTimeOfTakeOff) ? "hours" : "date"}
            />
          </Grid>
        </>
      }
    </When>
    <Grid item xs={12}>
      <TicketDescription values={props.values}/>
    </Grid>
  </EditorSection>
);

TicketDetails.defaultProps = {
  values: {},
  errors: [],
  touched: {},
  forcedRoundTrip: false,
  setFieldValue: () => null,
};

export default React.memo(TicketDetails);
